import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminDealershipService } from './admin-dealership.service';
import DataSource from 'devextreme/data/data_source';
import { buildDataSourceParams } from 'src/app/utils/requests';
import { PaginatedResult } from 'src/app/shared/interfaces/paginated-result';

@Component({
  selector: 'app-admin-dealerships',
  templateUrl: './admin-dealerships.component.html',
  styleUrls: ['./admin-dealerships.component.scss']
})
export class AdminDealershipsComponent implements OnInit {
  gridDataSource: any = {};

  constructor(
    private adminDealershipService: AdminDealershipService,
    private router: Router,
  ) {
    this.gridDataSource = new DataSource({
      key: 'id',
      load: async (loadOptions) => {
        const params = buildDataSourceParams(loadOptions);

        return new Promise((resolve, reject) => {
          this.adminDealershipService.getDealerships(params)
            .subscribe(async (data: PaginatedResult) => {
              resolve(data);
            }, (error) => {
              reject(error);
            });
        });
      },
    });
  }

  ngOnInit(): void {
  }

  edit(event) {
    if (event && event.id) {
      // this.router.navigate([`/admin/dealerships/details/${event.id}`]);
    }
  }

}
